export default () => {
    const staticBaseUrl = process.env.VUE_APP_STATIC_BASE_URL;
    const adwordsUrl = process.env.VUE_APP_ADWORDS_URL;
    return [
        {
            icon: `${staticBaseUrl}/landing-2020/Reforma.svg`,
            name: 'Reforma',
            url: `${adwordsUrl}/reforma/`,
            tagString: 'Reforma de comodos/ambientes'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/Recuperação de fachada.svg`,
            name: 'Recuperação de fachada',
            url: `${adwordsUrl}/reforma-de-fachadas/`,
            tagString: 'Fachadas - pintura, restauração ou reforma'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/Energia Solar.svg`,
            name: 'Energia Solar',
            url: `${adwordsUrl}/energia-solar/`,
            tagString: 'Sistemas de energia solar - instalação ou manutenção'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/Terceirização de mão-de-obra.svg`,
            name: 'Terceirização de mão-de-obra',
            url: `${adwordsUrl}/terceirizacao-de-mao-de-obra/`,
            tagString: 'Terceirização de auxiliar serviços gerais'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/Terceirização de limpeza.svg`,
            name: 'Terceirização de limpeza',
            url: `${adwordsUrl}/limpeza-e-conservacao/`,
            tagString: 'Terceirização de limpeza'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/CFTV.svg`,
            name: 'Portaria remota',
            url: `${adwordsUrl}/portaria-virtual/`,
            tagString: 'Portaria remota (eletrônica/virtual)'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/Terceirização de portaria.svg`,
            name: 'Terceirização de portaria',
            url: `${adwordsUrl}/terceirizacao-de-mao-de-obra/`,
            tagString: 'Terceirização de portaria'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/Laudo técnico de engenharia.svg`,
            name: 'Laudo técnico de engenharia',
            url: `${adwordsUrl}/laudo-tecnico-engenharia/`,
            tagString: 'Laudos, vistorias e perícias técnicas de estruturas'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/Vistoria predial.svg`,
            name: 'Vistoria predial',
            url: `${adwordsUrl}/autovistoria-predial/`,
            tagString: 'Autovistoria Predial'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/Impermeabilização.svg`,
            name: 'Impermeabilização',
            url: `${adwordsUrl}/impermeabilizacao/`,
            tagString: 'Impermeabilização em geral'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/Projeto de incêndio.svg`,
            name: 'Projeto de incêndio',
            url: `${adwordsUrl}/empresas-de-incendio/`,
            tagString: 'Projetos combate à incêndio e pânico'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/Instalação elétrica.svg`,
            name: 'Instalação elétrica',
            url: `${adwordsUrl}/instalacoes-eletricas/`,
            tagString: 'Instalações elétrica - construção ou reforma'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/Limpeza de reservatório.svg`,
            name: 'Limpeza de reservatório',
            url: `${adwordsUrl}/nova/`,
            tagString: 'Limpeza de caixas de água e reservatórios'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/Manutenção predial.svg`,
            name: 'Manutenção predial',
            url: `${adwordsUrl}/nova/`,
            tagString: 'Reforma de comodos/ambientes'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/Material de limpeza.svg`,
            name: 'Material de limpeza',
            url: `${adwordsUrl}/nova/`,
            tagString: 'Terceirização de limpeza'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/Pintura predial.svg`,
            name: 'Pintura predial',
            url: `${adwordsUrl}/empresa-de-pintura/`,
            tagString: 'Pintura de ambientes externos'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/CFTV.svg`,
            name: 'CFTV',
            url: `${adwordsUrl}/cftv/`,
            tagString: 'Sistemas CFTV - instalação ou manutenção'
        },
        {
            icon: `${staticBaseUrl}/landing-2020/Projeto de obra.svg`,
            name: 'Projeto de obra',
            url: `${adwordsUrl}/nova/`,
            tagString: 'Gerenciamento de obras e projetos'
        }
    ];
};
